import React from 'react';

/**
 * Componente input HTML con contador de caracteres
 * @param {Object} props - Propiedades del componente
 * @param {number} props.maxLength - Longitud máxima de caracteres permitidos
 * @param {string} props.value - Valor actual del input
 * @param {function} props.onChange - Función callback cuando cambia el valor
 * @param {string} props.id - ID del campo
 * @param {string} props.name - Name del campo
 * @param {string} props.placeholder - Placeholder del campo
 * @param {string} props.className - Clases CSS del input (por defecto: 'form-control')
 * @param {string} props.containerClassName - Clases CSS del contenedor (opcional)
 * @param {Object} props.counterStyle - Estilos personalizados para el contador
 * @param {boolean} props.showCounter - Mostrar u ocultar el contador (por defecto: true)
 * @param {string} props.counterPosition - Posición del contador: 'inside' (dentro del input) o 'bottom' (debajo del input). Por defecto: 'inside'
 * @param {*} rest - Cualquier otra prop que se pase se aplicará al input
 */
const InputWithCounter = ({ 
	maxLength = 100,
	value = '',
	onChange,
	id,
	name,
	placeholder = '',
	className = 'form-control',
	containerClassName = '',
	counterStyle = {},
	showCounter = true,
	counterPosition = 'inside',
	...rest 
}) => {
	const handleChange = (e) => {
		const newValue = e.target.value;
		if (newValue.length <= maxLength) {
			onChange && onChange(e);
		}
	};

	const currentLength = value ? value.length : 0;

	const wrapperStyle = {
		position: 'relative',
		display: counterPosition === 'inside' ? 'block' : 'block'
	};

	const inputStyle = counterPosition === 'inside' ? {
		paddingRight: '60px'
	} : {};

	const counterStyleInside = {
		position: 'absolute',
		right: '10px',
		top: '50%',
		transform: 'translateY(-50%)',
		fontSize: '0.75rem',
		color: '#666',
		pointerEvents: 'none',
		...counterStyle
	};

	const counterStyleBottom = {
		fontSize: '0.75rem',
		color: '#666',
		marginTop: '2px',
		textAlign: 'right',
		...counterStyle
	};

	const finalCounterStyle = counterPosition === 'inside' ? counterStyleInside : counterStyleBottom;

	return (
		<div className={containerClassName} style={counterPosition === 'inside' ? wrapperStyle : {}}>
			<input
				type="text"
				className={className}
				id={id}
				name={name}
				placeholder={placeholder}
				value={value}
				onChange={handleChange}
				maxLength={maxLength}
				style={inputStyle}
				{...rest}
			/>
			{showCounter && (
				<span style={finalCounterStyle}>
					{currentLength}/{maxLength}
				</span>
			)}
		</div>
	);
};

export default InputWithCounter;

